








































import { Component, Watch, Prop } from 'vue-property-decorator';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import { InstitutionAccountModule } from '@/store/Accounts/InstitutionAccountModule';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import ListUtils from '@/lib/listUtils';
import PaymentState from '@/models/Accounts/Shared/Payments/PaymentState';

@Component({ name: 'PaymentsFilterDialog' })
export default class extends SaascadaVueDialog {

    @Prop({required: true})
    isCustomerAccount: boolean;

    dialog = false;
    selectedPaymentState: PaymentState = null;

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            this.selectedPaymentState = this.filterByPaymentState;
        }
    }

    get filterByPaymentState() {
        if (this.isCustomerAccount) {
            return DepositAccountModule.filterByPaymentState;
        }
        else {
            return InstitutionAccountModule.filterByPaymentState;
        }
    }

    get paymentStateOptions() {
        return ListUtils.paymentOrderPaymentStateOptions();
    }

    async cancel() {
        this.dialog = false;
    }

    async save() {
        // Update the filters in the relevant module
        if (this.isCustomerAccount) {
            DepositAccountModule.updateFilterByPaymentState(this.selectedPaymentState);
        }
        else {
            InstitutionAccountModule.updateFilterByPaymentState(this.selectedPaymentState);
        }
        // Close dialog first then get payments again
        this.dialog = false;
        // Reset back to page 1 when changing the filter, in case the new list of payments only has 1 page
        if (this.isCustomerAccount) {
            await DepositAccountModule.getPayments(1);
        }
        else {
            await InstitutionAccountModule.getPayments({ id: this.$route.params.id, pageNumber: 1 });
        }
    }

}
